import { Routes } from './Routes/Router';

function App() {
  return (
    <div>
      <Routes/>
    </div>
  );
}

export default App;
